// extracted by mini-css-extract-plugin
export default {"info":"Footer_info__ME3XT","slide-content":"Footer_slide-content__fMVDz","active":"Footer_active__4Rxgl"};